module.exports = __webpack_public_path__ + "assets/img/block-hover-fd2fc170.png";